<div id="duplciate-attendees-modal">
  <!-- content -->
  <div *ngIf="!isLoadingDuplicates; else loading">
    <div *ngIf="!errorOccurred; else error">
      <!-- duplicates -->
      <div *ngIf="collectionSize > 0">
        <!-- instructions and info -->
        <div>
          <span>
            <h2 class="light-bold">
              Duplicados -
              {{ eventAndSessionData?.sessionName }} -
              {{ eventAndSessionData?.locatorId }}
            </h2>
          </span>
          <h4>
            Los colaboradores que se enlistan a continuaci&oacute;n ya tienen un
            registro del evento
            <span class="light-bold">
              {{ eventAndSessionData?.eventName }}
            </span>
            en su expediente. Si procedes, la sesi&oacute;n
            <span class="light-bold">
              {{ eventAndSessionData?.sessionName }}
            </span>
            (del mismo evento) se registrar&aacute; en los expedientes de los
            colaboradores.
          </h4>
          <p>
            Selecciona un justificante para los duplicados que desees conservar
            (puedes dar clic en el detalle si deseas saber qu&eacute; sesiones
            ya se encuentran registradas). Los registros que no se justifiquen
            se eliminar&aacute;n para evitar que lleguen a GBU.
          </p>
        </div>
        <!-- general justification for multiple duplicates -->
        <div
          *ngIf="selectedAttendees.size > 0"
          class="mb-2 d-flex align-items-center mt-2">
          <h3 class="me-3 mt-3">
            {{ selectedAttendees.size }} registros seleccionados
          </h3>
          <select
            class="form-select w-auto"
            [(ngModel)]="generalJustification"
            [ngClass]="getClassByJustification(generalJustification)"
            (change)="applyJustificationToSelected()">
            <option [ngValue]="-1" disabled class="neutral-row">
              -- Seleccionar --
            </option>
            <option [ngValue]="null" class="delete-row">
              Sin justificante
            </option>
            <option
              class="justification-row"
              *ngFor="let justification of justificationList"
              [ngValue]="justification.id">
              {{ justification.nombre }}
            </option>
          </select>
        </div>
        <!-- table -->
        <div class="table-responsive mt-3">
          <table
            class="table table-sm t-elevated-shadow-cap"
            aria-describedby="mydesc">
            <thead>
              <tr>
                <th scope="col">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    style="margin-right: 10px"
                    (change)="toggleSelectAll($event)"
                    [checked]="isAllSelected()" />
                </th>
                <th scope="col">N&uacute;mero de colaborador</th>
                <th scope="col">Nombre</th>
                <th scope="col">Justificante</th>
                <th scope="col">Detalle</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let element of duplicateAttendees
                    | slice: (page - 1) * pageSize : page * pageSize
                "
                [class]="getClassByJustification(element.fkIdJustificante)">
                <td>
                  <input
                    type="checkbox"
                    class="form-check-input"
                    style="margin-right: 10px"
                    [id]="'attendant' + element.numeroPersona"
                    [checked]="selectedAttendees.has(element.numeroPersona)"
                    (change)="toggleSelection(element.numeroPersona)" />
                </td>
                <td>
                  {{ element.numeroPersona }}
                </td>
                <td>{{ getFullName(element) }}</td>
                <td>
                  <select
                    [ngClass]="
                      getClassByJustification(element.fkIdJustificante)
                    "
                    class="form-select"
                    id="justification"
                    [(ngModel)]="element.fkIdJustificante">
                    <option [ngValue]="null" class="delete-row">
                      Sin justificante
                    </option>
                    <option
                      *ngFor="let justification of justificationList"
                      class="justification-row"
                      [ngValue]="justification.id">
                      {{ justification.nombre }}
                    </option>
                  </select>
                </td>
                <td>
                  <button
                    mat-icon-button
                    (click)="openOffcanvas(element)"
                    ngbTooltip="Detalle">
                    <span>
                      <mat-icon>visibility</mat-icon>
                    </span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- pagination -->
        <div class="d-flex justify-content-between p-2">
          <ngb-pagination
            [collectionSize]="collectionSize"
            [(page)]="page"
            [pageSize]="pageSize"
            [maxSize]="5"
            [rotate]="true"
            [boundaryLinks]="true">
          </ngb-pagination>

          <select
            class="form-select"
            style="width: auto"
            [(ngModel)]="pageSize">
            <option [ngValue]="10">10 registros por pagina</option>
            <option [ngValue]="20">20 registros por pagina</option>
            <option [ngValue]="50">50 registros por pagina</option>
          </select>
        </div>
      </div>
      <!-- no duplicates -->
      <div *ngIf="collectionSize === 0" class="confirm-dialog">
        <h2 class="light-bold">No se encontraron asistencias duplicadas</h2>
        <hr />
        <h3 class="light-bold">
          {{ noDuplicatesConfirmTitle }}
        </h3>
        <h3>¿Deseas continuar con el registro de asistencias?</h3>
        <p>{{ noDuplicatesConfirmMsg }}</p>
      </div>
    </div>

    <app-off-canvas [options]="offCanvasOptions" #offcanvasComponent>
      <ng-container *ngIf="selectedAttendant">
        <app-duplicate-detail-by-attendant
          [eventAndSessionData]="eventAndSessionData"
          [attendant]="selectedAttendant"
          (closeOffCanvasEmitter)="
            offcanvasComponent.close()
          "></app-duplicate-detail-by-attendant>
      </ng-container>
    </app-off-canvas>
  </div>

  <!-- close and continue btn -->
  <div class="d-flex justify-content-center align-content-center mb-2 mt-3">
    <div class="col-3 mx-1 p-1">
      <button
        type="button"
        (click)="onContinue()"
        class="btn btn-primario"
        [disabled]="isLoadingConfirmBtn || isLoadingDuplicates">
        <ng-container *ngIf="!isLoadingConfirmBtn; else loadingBtn">
          <span>Continuar</span>
        </ng-container>
        <ng-template #loadingBtn>
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"></span>
          <span class="sr-only">Cargando...</span>
        </ng-template>
      </button>
    </div>
    <div class="col-3 mx-1 p-1">
      <button
        type="button"
        (click)="closePopUp(false)"
        class="btn btn-secondary-cap">
        <span>Cancelar</span>
      </button>
    </div>
  </div>
  <!-- loader -->
  <ng-template #loading>
    <app-loading-spinner
      loadingText="Verificando duplicados..."></app-loading-spinner>
  </ng-template>
  <!-- error on loading -->
  <ng-template #error>
    <div
      class="d-flex flex-column align-items-center mb-2 mt-3 text-center"
      *ngIf="errorOccurred">
      <div>
        <h3 class="form-text text-danger mt-3">
          Ha ocurrido un error al verificar duplicados.
        </h3>
        <h4 (click)="closePopUp(false)" style="cursor: pointer">
          Da click aqu&iacute; para cerrar el modal
        </h4>
      </div>
    </div>
  </ng-template>
</div>
